import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_alert = _resolveComponent("el-alert");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  return _openBlock(), _createBlock(_component_el_config_provider, {
    locale: $options.elementLocale
  }, {
    default: _withCtx(() => [_createVNode(_component_router_view), _createVNode(_component_el_dialog, {
      modelValue: $options.adminAuthWarningVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $options.adminAuthWarningVisible = $event),
      title: _ctx.$t('adminAuthWarning.title'),
      width: 'min(480px, 90vw)',
      "close-on-click-modal": false,
      "close-on-press-escape": false
    }, {
      footer: _withCtx(() => [_createVNode(_component_el_button, {
        onClick: $options.openSecuritySettings
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('adminAuthWarning.configure')), 1)]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$store.commit('dismissAdminAuthWarning'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('adminAuthWarning.close')), 1)]),
        _: 1
      })]),
      default: _withCtx(() => [_createVNode(_component_el_alert, {
        title: _ctx.$t('adminAuthWarning.message'),
        type: "warning",
        "show-icon": "",
        closable: false,
        class: "admin-auth-warning-message"
      }, null, 8, ["title"])]),
      _: 1
    }, 8, ["modelValue", "title"])]),
    _: 1
  }, 8, ["locale"]);
}